import { Button, Box } from '@mui/material';
import { Formik, Form} from 'formik';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AsyncBackdropSubmit from '../../../components/AsyncBackdropSubmit';
import FormStepperBuilder from '../../../components/form_v2/highLevelComponents/FormStepperBuilder';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import TitlePage from '../../../components/layout/Page/TitlePage';
import FormSkeleton from '../../../components/Skeletons/FormSkeleton';
import { fetchContributorsTypesOptions, fetchErgoTypesOptions, fetchOAtypeFormat, getErgo } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues, isSubmitEnabled } from '../../../lib/helperFuncs';
import HttpService from '../../../services/HttpService';
import { initialValuesEditErgo } from '../Registrations/types';
import { editProjectValidation } from '../Registrations/validationSchema';
import PreviewErgo from './PreviewErgo';
import { insertErgoFields } from './static';
import AddIcon from '@mui/icons-material/Add';
import DialogAddContributor from '../../../components/Dialog/DialogAddContributor';

const EditErgo = () => {
  document.title = 'Επεξεργασία Ο/Α Έργου';

  const [ omekaResponse, setOmekaResponse ] = React.useState<any>({});
  const [typeOptions, setTypeOptions] = React.useState<any[]>([]);
  const [locations, setLocations] = React.useState<any[]>([]);
  const [contributors, setContributors] = React.useState<any[]>([]);
  const [isLoadingErgo, setIsLoadingErgo] = React.useState(true);
  const [renderPreview, setRenderPreview] = React.useState(false);
  const [openBackdrop, setOpenBackdrop] = React.useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [formatOptions, setFormatOptions] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [contributorsOptions, setContributorsOptions] = React.useState<any[]>([]);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { id } = useParams();
  

  const handleClickOpen = () => {
    setOpen(true);
  };

  const fetchErgo = async (ergo_id: string) => {
    try {
      setIsLoadingErgo(true);
      const {project: ergo_object} = await getErgo(ergo_id);
      setOmekaResponse(ergo_object);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingErgo(false);
    }
  };

  const getTypeOptions = async () => {
    try {
      const response = await fetchErgoTypesOptions(); 
      const _ergoTypeOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));          
      setTypeOptions(_ergoTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getLocations = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics`);    
      const _locationsOptions = response.data
        .map((x:any) => {
          return {
            key: x.key, 
            value: x.value
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));                
      setLocations(_locationsOptions);
    } catch (error) {
      console.error(error);
    }
  };
  
  const getContributorsOptions = async () => {
    try {
      const response = await fetchContributorsTypesOptions();
      const _contributorsTypeOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));        
      setContributorsOptions(_contributorsTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getTypeFormat = async () => {
    try {
      const response = await fetchOAtypeFormat();
      const _projectFormatOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));
      setFormatOptions(_projectFormatOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getContributors = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/suntelestes/parametrics`);  
      const _contributorsOptions = response?.data.map((x:any) => {
        return {
          key: x.key, 
          value: x.value
        };
      })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));                
      setContributors(_contributorsOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmitContributorForm = async (values: any) => {
    setIsLoading(true);
    try {
      
      const resp = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/suntelestes`, values);
      setContributors([
        ...contributors, 
        ...[{ key: `${resp.data.title} - ${resp.data.role}`, value: resp.data.id }]
      ]);
      
      enqueueSnackbar('Επιτυχής δημιουργία Eμπλεκόμενου', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });
    }
    setIsLoading(false);
    setOpen(false);
  };

  const onSubmitEdit = async (values: any) => {
    setOpenBackdrop(true);
    try {      
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/ergo/${omekaResponse.id}`,
        eliminateOjectNotTruthyValues({
          ...values,
        })
      );
      enqueueSnackbar('H καταχώριση έργου υποβλήθηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/project/dashboard');
      localStorage.removeItem('ergoId');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('H καταχώριση έργου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } 
    setOpenBackdrop(false);
  };

  React.useEffect(() => {
    searchParams.delete('edit');
    searchParams.delete('preview');
    setSearchParams(searchParams);

    id && fetchErgo(id);

    Promise.all([
      getLocations(),
      getContributors(),
      getTypeOptions(),
      getTypeFormat(),
      getContributorsOptions()
    ]);
  }, []);


  // Set confirmation message in case someone wants to refresh or leave the page
  React.useEffect(() => {
    const unloadCallback = (event: any) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };
    
    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);
  
  return (
    <>
      <AsyncBackdropSubmit isLoading={openBackdrop}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <TitlePage 
        backButton={false}
        title={Object.prototype.hasOwnProperty.call(Object.fromEntries([...searchParams]), 'preview')
          ? 'Προεπισκόπηση Επεξεργασίας Ο/Α Έργου'
          : 'Επεξεργασία Ο/Α Έργου'
        }/>
      {isLoadingErgo
        ? <FormSkeleton lines={6}/>
        : !renderPreview
          ? <>
            <Box mt={3} justifyContent='end'
              display='flex'> 
              <Button
                variant='contained'
                color='primary'
                startIcon={<AddIcon />}
                onClick={handleClickOpen}>
                Προσθήκη Νέου Εμπλεκόμενου
              </Button>
              <DialogAddContributor title={'Καταχώριση Εμπλεκόμενου Έργου'} 
                open={open}
                isLoading={isLoading}
                contributors={contributors}
                options={contributorsOptions}
                handleClose={()=> setOpen(false)}
                onAccept={onSubmitContributorForm}
              />
            </Box>
            <Formik
              enableReinitialize
              onSubmit={()=> undefined}
              initialValues={initialValuesEditErgo(omekaResponse)}
              validationSchema={editProjectValidation}
            >
              {formik =>
                (<>
                  <Form>
                    <FormStepperBuilder formik={formik} form={insertErgoFields(typeOptions,
                      locations, contributors, formatOptions)}/>
                    <FormActionButtonLayout>
                      <Button 
                        variant='outlined' 
                        color='error'
                        onClick={() => navigate('/admin/project/dashboard')}
                      > 
                        Ακύρωση Επεξεργασίας          
                      </Button>
                      <Button 
                        variant='contained' 
                        disabled={isSubmitEnabled(formik?.errors, true)}
                        onClick={() => {
                          setOmekaResponse({...formik.values} as any);
                          searchParams.set('preview', 'true');
                          searchParams.delete('edit');
                          setSearchParams(searchParams);
                          setRenderPreview(true);
                        }}
                      > 
                        Προεπισκόπηση Καταχώρισης
                      </Button>
                    </FormActionButtonLayout>
                  </Form>
                </>)
              }
            </Formik>
          </>
          : <PreviewErgo
            onSubmit={onSubmitEdit}
            data={omekaResponse} 
            setRenderPreview={setRenderPreview}
            isLoading={isLoadingErgo}
          />
      }
    </>
  );
};

export default EditErgo;